var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvestmentVehicles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5556 3.53079C18.5556 3.08902 18.2657 2.69957 17.8426 2.57279L13.8426 1.37279C13.655 1.31649 13.4551 1.31649 13.2676 1.37279L9.26756 2.57279C8.84477 2.69994 8.55539 3.08929 8.55556 3.53079V8.60979C8.55582 9.01861 8.80491 9.38611 9.18456 9.53779L13.1846 11.1378C13.423 11.2332 13.6891 11.2332 13.9276 11.1378L17.9276 9.53779C18.3068 9.38579 18.5555 9.01837 18.5556 8.60979V3.53079Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3006 2.86377L13.5556 4.28677L8.81056 2.86377",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5556 4.25V11.25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5556 13.6336C23.5556 13.4253 23.4265 13.2389 23.2316 13.1656L19.7316 11.8536C19.6184 11.8112 19.4937 11.8112 19.3806 11.8536L15.8806 13.1656C15.6856 13.2389 15.5566 13.4253 15.5566 13.6336V17.4776C15.5566 17.6668 15.6634 17.8398 15.8326 17.9246L19.3326 19.6746C19.4733 19.7449 19.6389 19.7449 19.7796 19.6746L23.2796 17.9246C23.4487 17.8398 23.5556 17.6668 23.5556 17.4776V13.6336Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4496 13.3267L19.5556 14.7867L15.6626 13.3267",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5556 14.75V19.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5556 15.0076C13.5557 14.577 13.2801 14.1946 12.8716 14.0586L7.87156 12.3916C7.66643 12.3233 7.44468 12.3233 7.23956 12.3916L2.23956 14.0586C1.83101 14.1946 1.55545 14.577 1.55556 15.0076V21.5666C1.55545 21.9972 1.83101 22.3795 2.23956 22.5156L7.23956 24.1826C7.44468 24.2509 7.66643 24.2509 7.87156 24.1826L12.8716 22.5156C13.2801 22.3795 13.5557 21.9972 13.5556 21.5666V15.0076Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3216 14.3647L7.55555 16.2867L1.78955 14.3647",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.55556 16.25V24.25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentVehicles);
export default __webpack_public_path__ + "static/media/investment-vehicles.a4837491bb4b909a60719b98615e2e47.svg";
export { ForwardRef as ReactComponent };